let singleProductPage = document.querySelector('.single-product');

if (singleProductPage) {
    let saldoInput = document.querySelector('.saldo-wrapper input.saldo');
    saldoInput.setAttribute("step", "0.01");
}
